import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import Slidemenubutton from './app/slidemenubutton.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import SpanWrap from './app/spanwrap.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import slick from "slick-carousel/slick/slick.js";

import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slickCss from "slick-carousel/slick/slick.scss";
import slickTheme from "slick-carousel/slick/slick-theme.scss";

import {tns} from "tiny-slider/src/tiny-slider.js";
import tnscss from "tiny-slider/dist/tiny-slider.css"
import ScrollReveal from "./app/scrollreveal";
import anime from "animejs";

window.sr = new ScrollReveal({duration: 600, mobile: true});

class App {
  constructor() {
    new Utils();
    new Accordion();
    new Anchor();
    new FixedHeader();
    new HeightLine();
    new ResponsiveTable();
    new Slidebar();
    new CurrentNav();
    new Tab();
    new Slidemenubutton();
    this.SpanWrap = new SpanWrap();
    this.initialize();
  }

  initialize() {
    $(() => {
      this.menuSlide();
      this.SpanWrap.init();
      // this.siteAnimations();
      this.closeButton();
      this.owlCarousel();
      this.slickSlider();
      this.tinySlider();
      this.messageModal();
      this.recruitMainVisual();
    });
  }

  //フッターメニューSPスライド
  menuSlide() {
    let win = $(window).innerWidth();
    if (win > 750) {
      return false;
    }
    $('.l-footer__block').on('click', function () {
      $(this).children(".l-footer__menutitle").toggleClass('is-open');
      $(this).children(".l-footer__menulist.is-sub").slideToggle();
    })
  }

  /**
   * 採用のメインビジュアル
   */
  recruitMainVisual() {
    if ($(".c-main-visual-recruit").length) {
      $(".c-main-visual-recruit__text,.c-main-visual-recruit__bg__01,.c-main-visual-recruit__bg__02").css({
        clipPath: 'inset(0 100% 0 0)'
      });
      anime({
        targets: ".c-main-visual-recruit__bg__01",
        opacity: [0, 0, 1, 0.8, 1],
        // scale: [0.8, 1],
        easing: 'easeInOutQuad',
        // translateX: [0],
        marginLeft: [-30, 0, 0, 0],
        duration: 1000,
        keyframes: [
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 0% 0 0)'}, // end frame
        ],
        delay: 0,
      });
      anime({
        targets: ".c-main-visual-recruit__bg__02",
        opacity: [0, 0, 1, 0.8, 1],
        // scale: [0.8, 1],
        easing: 'easeInOutQuad',
        // translateX: [0],
        marginLeft: [-30, 0, 0, 0],
        duration: 1000,
        keyframes: [
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 0% 0 0)'}, // end frame
        ],
        delay: 300,
      });
      anime({
        targets: ".c-main-visual-recruit__text",
        opacity: [0, 0, 1, 0.8, 1],
        // scale: [0.8, 1],
        easing: 'easeInOutQuad',
        // translateX: [0],
        marginLeft: [-30, 0, 0, 0],
        duration: 1000,
        keyframes: [
          {clipPath: 'inset(0 0 0 100%)'}, // start frame
          {clipPath: 'inset(0 0 0 0% )'}, // end frame
        ],
        delay: 1000,
      });
    }
  }

  /**
   * domをeach
   * @param items
   * @param callback
   */
  domEach(items, callback) {
    if (typeof items === "string") {
      var items = $(items);
    }
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      // callback = callback.bind(item)
      callback(i, item);
    }
  }

  /**
   * メインビジュアルのアニメーション
   */
  textAnimation(selector01, selector02) {
    if (!selector01) {
      selector01 = ".js-letter-c";
    }
    if (!selector02) {
      selector02 = ".js-letter-o";
    }
    $(selector01).attr("style", "");
    $(selector02).attr("style", "");


    this.domEach(".js-letter-parent", function (key, item) {
      var delay = item.getAttribute("data-delay")
      if (!delay) {
        delay = 0;
      }

      var selector01El = item.querySelector(selector01)
      sr.reveal(selector01El, {
        opacity: [0, 0.4, 0.4],
        easing: "cubicBezier(.165,.84,.44,1)",
        translateX: [100, 0, 0],
        duration: 800,
        keyframes: [
          {clipPath: 'inset(0 0 0 100%)'}, // start frame
          {clipPath: 'inset(0 0 0 0%)'}, // end frame
        ],
        delay: anime.stagger(120, {start: delay - 0}),
        complete: function (anim) {
          $(selector01El).remove()
        }
      });
      var selector02El = item.querySelector(selector02)
      sr.reveal(selector02El, {
        opacity: [0, 0, 0.5, 1],
        easing: "cubicBezier(.165,.84,.44,1)",
        translateX: [0, 0],
        duration: 600,
        keyframes: [
          {clipPath: 'inset(0 100% 0 0)'}, // start frame
          {clipPath: 'inset(0 0% 0 0)'}, // end frame
        ],
        delay: anime.stagger(120, {start: 300 + (delay - 0)}),
      });

      if ($(item).find(".c-button").length) {
        $(selector01El).css("width", "100%");
        $(selector02El).css("width", "100%");
      }
    });
  }

  textInitializeForAnimation(selector) {
    let $parents = $(selector);
    if ($parents.length) {
      for (let i = 0; i < $parents.length; i++) {
        let $parent = $($parents[i]);
        $parent.addClass("js-letter-parent");
        let _html = $parent.html();
        $parent.html("")
        let $originalText = $("<span />", {
          class: "js-letter-o",
          html: _html,
        });
        let $cloneText = $("<span />", {
          class: "js-letter-c",
          html: _html,
        });
        $parent.append($originalText);
        $parent.append($cloneText);
      }
    }
  }

  /**
   * スクロールリーバルの実行
   */
  siteAnimations() {
    let baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
    let baseDistance = '8';

    sr.reveal(".c-main-visual", {
      duration: 1400,
      opacity: 1,
      //translateY: -baseDistance,
      delay: 900,
    }, 100);

    this.domEach(".c-card-sm__block", function (key, item) {
      sr.reveal(item, {
        scale: {
          value: [0.9, 1],
          // easing: "linear"
        },
        opacity: 1,
        duration: 600,
        delay: 100 * key,
        translateY: [-baseDistance, 0],
        easing: baseEasing
      });
    });

    this.domEach(".c-banners__block", function (key, item) {
      sr.reveal(item, {
        opacity: [0, 1],
        easing: baseEasing,
        // translateX: [0],
        duration: 800,
        clipPath: ['inset(0 100% 0 0%)', 'inset(0 0% 0 0)'],
        delay: 500 * key,
      });
    });

    this.domEach(".c-recruit-banner", function (key, item) {
      sr.reveal(item, {
        opacity: [0, 1],
        easing: baseEasing,
        // translateX: [0],
        duration: 600,
        clipPath: ['inset(0 0 0 100%)', 'inset(0 0% 0 0)'],
        delay: 100 * key,
      });
    });
    this.domEach(".c-card-icon__block > *", function (key, item) {
      sr.reveal(item, {
        opacity: [0, 1],
        easing: "easeInOutQuad",
        translateY: [-7, 0],
        duration: 400,
        delay: 80 * key,
      });
    });

    /**
     * 採用トップ
     */
    this.domEach(".is-black .c-hero-block-square__image,.is-primary .c-hero-block-square__content", function (key, item) {
      sr.reveal(item, {
        opacity: [0, 1],
        easing: baseEasing,
        duration: 1200,
        clipPath: ['inset(0 0 0 100%)', 'inset(0 0% 0 0)'],
        delay: 100 * key,
      });
    });
    this.domEach(".is-black .c-hero-block-square__content,.is-primary .c-hero-block-square__image", function (key, item) {
      sr.reveal(item, {
        opacity: [0, 1],
        easing: baseEasing,
        // translateX: [0],
        duration: 1200,
        clipPath: ['inset(0 100% 0 0)', 'inset(0 0% 0 0)'],
        delay: 100 * key,
      });
    });

    this.textInitializeForAnimation(".c-heading.is-xxlg span");
    this.textInitializeForAnimation(".c-heading.is-xxlg small");
    this.textInitializeForAnimation(".js-letter-animation");
    // this.domEach(".js-letter-o", function (key, item) {
    this.textAnimation()
    // });
  }

  closeButton() {
    $('.c-slidebar-menu__button').on('click', function () {
      $('body').removeClass('is-slidebar-active');
    });
  }

  /**
   * メインビジュアルのアニメーション
   */
  slideAnimation() {
    $(".c-main-slider-item__container span").attr("style", "");
    anime({
      targets: ".owl-item.active .c-main-slider-item__container:nth-child(1) span",
      opacity: [0, 0, 0.4],
      easing: "cubicBezier(.165,.84,.44,1)",
      translateX: [100, 0],
      duration: 400,
      keyframes: [
        {clipPath: 'inset(0 0 0 100%)'}, // start frame
        {clipPath: 'inset(0 0 0 0%)'}, // end frame
      ],
      delay: anime.stagger(120),
    });
    anime({
      targets: ".owl-item.active .c-main-slider-item__container:nth-child(2) span",
      opacity: [0, 0, 0.5, 1],
      easing: "cubicBezier(.165,.84,.44,1)",
      translateX: [0, 0],
      duration: 400,
      keyframes: [
        {clipPath: 'inset(0 100% 0 0)'}, // start frame
        {clipPath: 'inset(0 0% 0 0)'}, // end frame
      ],
      delay: anime.stagger(120, {start: 0}),
    });
  }


  /**
   * owl-carousel
   * @returns {boolean}
   */
  owlCarousel() {
    var owls = $('.owl-carousel');
    if (owls.length === 0) {
      return false
    }
    //->スライダー
    owls.imagesLoaded(() => {
      let $mainvisual = $('.c-main-visual__slider').owlCarousel({
        items: 1,
        margin: 0,
        dots: true,
        loop: true,
        nav: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        autoplayTimeout: 6000,
        autoplayHoverPause: false,
        autoplay: true,
        smartSpeed: 500,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        navText: false,
      });
      setTimeout(() => {
        this.slideAnimation();
      }, 1500)

      $mainvisual.on('changed.owl.carousel', (e) => {
        setTimeout(() => {
          this.slideAnimation();
        }, 300)
      });
    });
    //->カード_カルーセル
    owls.imagesLoaded(() => {
      $('.js-card-slider').owlCarousel({
        margin: 0,
        dots: true,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoWidth: false,
        autoHeight: false,
        center: true,
        navText: ['<span class="is-prev"><i class="fa fa-angle-left"></i></span>', '<span class="is-next"><i class="fa fa-angle-right"></i></span>'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
          },
          // breakpoint from 750 up
          750: {
            items: 3,
          }
        }
      });
    });
    owls.imagesLoaded(() => {
      $('.js-interview-slider').owlCarousel({
        margin: 40,
        dots: false,
        loop: true,
        nav: true,
        autoplayHoverPause: true,
        autoplay: true,
        autoplaySpeed: 900,
        autoWidth: true,
        autoHeight: false,
        center: false,
        // slideBy: 2,
        navText: ['<span class="is-prev"><i class="fa fa-angle-left"></i></span>', '<span class="is-next"><i class="fa fa-angle-right"></i></span>'],
        responsive: {
          // breakpoint from 0 up
          0: {
            items: 1,
            margin: 20,
            autoWidth: true,
            center: true,
          },
          // breakpoint from 750 up
          950: {
            items: 3,
          }
        }
      });
    });
  }

  /**
   * 採用のモーダル
   */
  messageModal() {
    let $items = $(".c-message-item");
    for (let i = 0; i < $items.length; i++) {
      $($items[i]).modaal({
        type: 'inline',
        content_source: $($items[i]).find(".c-message-item__modal"),
        width: 700,
        close_text: "<img src='/assets/images/icon-modal-close.svg'"
      });
    }
  }

  /**
   * 採用の縦方向スライダー
   */
  tinySlider() {
    if ($(window).width() < 768) {
      return;
    }
    if ($('.c-r-front-message__carousel__items').length) {
      var slider = tns({
        container: '.c-r-front-message__carousel__items',
        items: 3,
        axis: "vertical",
        touch: true,
        mouseDrag: true,
        // rewind: true,
        nav: true,
        controls: true,
        controlsText: ["", ""],
        autoplayButtonOutput: false,
        // swipeAngle: true,
        autoplayDirection: "forward",
        speed: 800,
        loop: true,
        autoplay: true,
        autoplayButton: false,
        autoplayHoverPause: true,
        autoplayTimeout: 3500,
      });
    }
  }

  /**
   * slickのスライダー
   */
  slickSlider() {

    $('.c-block-slider__main').slick({
      infinite: true,
      arrow: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // prevArrow: '<div class="slick-prev" style="background-image:url(/assets/images/icon-slider-prev-lg.png)"></div>',
      // nextArrow: '<div class="slick-next" style="background-image:url(/assets/images/icon-slider-next-lg.png)"></div>',
      asNavFor: '.c-block-slider__thumbnail',
      autoplaySpeed: 2500,
      // centerPadding: '23.28%',
      //centerMode: true,
      variableWidth: true,
      responsive: [{
        breakpoint: 750,
        settings: {
          dots: false,
          variableWidth: false,
          autoplaySpeed: 2500,
          slidesToShow: 1
        }
      }]
    });
    $('.c-block-slider__thumbnail').slick({
      accessibility: true,
      autoplay: false,
      autoplaySpeed: 4000,
      speed: 400,
      arrows: true,
      dots: false,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.c-block-slider__main',
      focusOnSelect: true,
      prevArrow: '<div class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>',
      nextArrow: '<div class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>',
      responsive: [{
        breakpoint: 750,
        settings: {
          dots: false,
          variableWidth: false,
          autoplaySpeed: 2500,
          slidesToShow: 2
        }
      }]
    });
  }

}

window.GApp = new App();
